/**
 * Inverse encaissement / avoir / debt initial receipt split lines.
 * Cash must credit a physical caisse; non-cash must credit a bank caisse (same rule as décaissement payments).
 */

export const ENCAISSEMENT_BANK_FUND_METHODS = ["cheque", "traite", "virement", "tpe"];

export const ENCAISSEMENT_PHYSICAL_FUND_METHODS = ["cash", ...ENCAISSEMENT_BANK_FUND_METHODS];

/** Method dropdown options (user picks method first; fund UI follows). */
export const ENCAISSEMENT_SPLIT_LINE_METHODS = ["cash", "cheque", "virement", "traite", "tpe"];

/** @deprecated Prefer method-first UI + ENCAISSEMENT_SPLIT_LINE_METHODS */
export function encaissementMethodsForFundDestination(fundDestination) {
  return fundDestination === "caisseBank"
    ? ENCAISSEMENT_BANK_FUND_METHODS
    : ENCAISSEMENT_PHYSICAL_FUND_METHODS;
}

/** @deprecated Prefer onLineMethodChange syncing fund/method */
export function normalizeEncaissementMethodForFundDestination(fundDestination, currentMethod) {
  const allowed = encaissementMethodsForFundDestination(fundDestination);
  return allowed.includes(currentMethod) ? currentMethod : allowed[0];
}
